import React, { useState } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { BsXCircle } from 'react-icons/bs';  // Utiliser une icône croix (X) rouge
import { useQuery } from 'react-query';
 
import '../utils/style.css';
//import images
import avatar2 from "../../../assets/images/users/avatar-user.png";
import avatar8 from "../../../assets/images/users/avatar-user.png";
import avatar3 from "../../../assets/images/users/avatar-user.png";
import avatar6 from "../../../assets/images/users/avatar-user.png";
import bell from "../../../assets/images/bell.svg";
//SimpleBar
import SimpleBar from "simplebar-react";
import { useTranslation } from 'react-i18next';
import AllNotification from '../component/AllNotifcation';
import AllNotificationNonLue from '../component/AllNotifcationNonLue';
import AllNotificationInspection from '../component/AllNotifcationInspection';

import AllNotificationInspComplete from '../component/AllNotifcationInspComplete';
import AllNotificationIncident from '../component/AllNotificationIncident';

const Notifications = () => {
    const {t}=useTranslation();
    //Dropdown Toggle
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const toggleNotification = () => {
        setIsNotificationDropdown(!isNotificationDropdown);
    };
    // Gérer la visibilité de "4 New"
    const [isNewVisible, setIsNewVisible] = useState(true);

    const handleCloseDropdown = () => {
        setIsNotificationDropdown(false); // Fermer le menu déroulant
    };
    //Tab 
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const tabs = [ t('notification.activited'),  t('notification.inspection'), t('notification.incident'),t('notification.inspComplete'),];
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

    return (
        <React.Fragment>
            <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotification} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-bell fs-22'></i>
                    <span
                        className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">3<span
                            className="visually-hidden">unread messages</span></span> 
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-startend p-0" style={{
                        width: '600px', 
                        fontSize: '16px', 
                        position: 'absolute', 
                        right: '0', 
                        left: 'auto' , 
                        
                    }}>

                    <div className="dropdown-head  rounded-top">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <div className='titleNotif'> {t("notification.notifications")}</div>
                                </Col>
                                <div className="col-auto dropdown-tabs">
                                {isNewVisible && (
                                        <button  style={{color:'#F22A2A'}}
                                        onClick={handleCloseDropdown} 
                                            className="btn btn-link p-0 ms-2 text-danger"
                                        >
                                            <BsXCircle size={18} />
                                        </button>
                                    )}
                                </div>
                            </Row>
                            
                        </div>
                        <div className="px-2 pt-2">
    <Nav  className="nav-tabs dropdown-tabs nav-tabs-custom">
        <NavItem>
            <NavLink className='notification'
                style={{
                    fontWeight: activeTab === '1' ? '500px' : 'normal',
                    color: activeTab === '1' ? '#252525' : '#9E9E9E', 
                    borderBottom: activeTab === '1' ? '2px solid #595959' : 'none' 
                }}
                onClick={() => { toggleTab('1'); }}
            >
            {t("notification.all")}
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink className='notification'
                style={{
                    fontWeight: activeTab === '5' ? '500px' : 'normal',
                    color: activeTab === '5' ? '#252525' : '#9E9E9E', 
                    borderBottom: activeTab === '5' ? '2px solid  #595959' : 'none' 
                }}
                onClick={() => { toggleTab('5'); }}
            >
               {t("notification.nonLue")}
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink className='notification'
                style={{
                    fontWeight: activeTab === '6' ? '500px' : 'normal',
                    color: activeTab === '6' ?'#252525' : '#9E9E9E', 
                    borderBottom: activeTab === '6' ? '2px solid  #595959' : 'none' 
                }}
                onClick={() => { toggleTab('6'); }}
            >
              {t("notification.archive")}
            </NavLink>
        </NavItem>
    </Nav>
</div>

<hr style={{marginTop:'1px',color:'#D3D3D3',border:'1px solid'}}></hr>

                    </div>
                    <Row  style={{marginTop:'20px'}}>
                    <div className="tab-container">
                        <button className="big-button">
                            <div className="tab-container-wrapper">
                                {tabs.map((tab, index) => (
                                    <button
                                        key={index}
                                        className={`tab-button ${activeTab === (index + 1).toString() ? "active" : ""}`}
                                      
                                        onClick={() => toggleTab((index + 1).toString())}
                                    >
                                        {tab}
                                    </button>
                                ))}
                            </div>
                        </button>
                    </div>
                </Row>


                        <TabContent     style={{
                            marginTop: '10px',
                            maxHeight: '90vh',  
                            overflowY: 'auto',   
                        }} activeTab={activeTab}>
                            <TabPane tabId="1" className="py-2 ps-1">
                                <SimpleBar style={{ maxHeight: "" }} className="pe-2">
                                    <AllNotification/>                             
                                </SimpleBar>
                            </TabPane>

                            <TabPane tabId="2" className="py-2 ps-1">
                                <SimpleBar style={{ maxHeight: "" }} className="pe-2">
                                    <AllNotificationInspection/>                             
                                </SimpleBar>
                            </TabPane>
                            <TabPane tabId="3" className="py-2 ps-1">
                                <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                    <AllNotificationIncident/>                             
                                </SimpleBar>
                            </TabPane>
                        
                           
                            <TabPane tabId="4" className="py-2 ps-1">
                                <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                    <AllNotificationInspComplete/>                             
                                </SimpleBar>
                            </TabPane>
                        <TabPane tabId="5" className="py-2 ps-1">
                                <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                    <AllNotificationNonLue/>                             
                                </SimpleBar>
                            </TabPane>
                            <TabPane tabId="6" className="p-4">
                            <div className="w-25 w-sm-50 pt-3 mx-auto">
                                <img src={bell} className="img-fluid" alt="user-pic" />
                            </div>
                            <div className="text-center pb-5 mt-2">
                                <div className="   alerte">Pas de notifications archivée pour l'instant 👦 </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
    
};

export default Notifications;